// src/v2/pages/Reports/ReportR5.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportR5 } from '../../hooks/useReportR5';
import { ReportR5Module } from '../../components/modules/Reports/ReportR5/ReportR5Module';

const ReportR5 = ({ isHideSideMenu }) => {
  const reportHook = useReportR5();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportR5Module reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportR5;